<div class="contact-upper-component field-font-small" style="width:100%;clear:both;">
    <mat-tab-group>
        <mat-tab label="Contexte">
            <mat-form-field class="field-full-width" appearance="legacy">
                <mat-label>Motif</mat-label>
                <textarea matInput [(ngModel)]="contact.cardio.complaints.reason" class="field-textarea"></textarea>
            </mat-form-field>
            <mat-form-field class="field-full-width" appearance="legacy">
                <mat-label>Plaintes</mat-label>
                <textarea matInput [(ngModel)]="contact.cardio.complaints.complaints" class="field-textarea"></textarea>
            </mat-form-field>
            <mat-form-field class="field-full-width" appearance="legacy">
                <mat-label>Anamnèse</mat-label>
                <textarea matInput [(ngModel)]="contact.cardio.complaints.anamesis" class="field-textarea"></textarea>
            </mat-form-field>
        </mat-tab>
        <mat-tab label="Clinique">
            <div fxLayout="row" fxLayoutGap="10px">
                <div fxFlex="33%">
                    <mat-form-field class="field-full-width" appearance="legacy">
                        <mat-label>Etat général</mat-label>
                        <textarea matInput [(ngModel)]="contact.cardio.clinicalexam.general" class="field-textarea"></textarea>
                    </mat-form-field>
                </div>
                <div fxFlex="33%">
                    <mat-form-field class="field-full-width" appearance="legacy">
                        <mat-label>Coeur</mat-label>
                        <textarea matInput [(ngModel)]="contact.cardio.clinicalexam.heart" class="field-textarea"></textarea>
                    </mat-form-field>
                </div>
                <div fxFlex="33%">
                    <mat-form-field class="field-full-width" appearance="legacy">
                        <mat-label>Poumons</mat-label>
                        <textarea matInput [(ngModel)]="contact.cardio.clinicalexam.lungs" class="field-textarea"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div fxLayout="row" fxLayoutGap="10px">
                <div fxFlex="33%">
                    <mat-form-field class="field-full-width" appearance="legacy">
                        <mat-label>Carotides</mat-label>
                        <textarea matInput [(ngModel)]="contact.cardio.clinicalexam.carotids" class="field-textarea-medium"></textarea>
                    </mat-form-field>
                </div>
                <div fxFlex="33%">
                    <mat-form-field class="field-full-width" appearance="legacy">
                        <mat-label>Reflux hépato-jugulaire</mat-label>
                        <textarea matInput [(ngModel)]="contact.cardio.clinicalexam.relux" class="field-textarea-medium"></textarea>
                    </mat-form-field>
                </div>
                <div fxFlex="33%">
                    <mat-form-field class="field-full-width" appearance="legacy">
                        <mat-label>Pression veineuse centrale</mat-label>
                        <textarea matInput [(ngModel)]="contact.cardio.clinicalexam.pressure" class="field-textarea-medium"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div fxLayout="row" fxLayoutGap="10px">
                <div fxFlex="33%">
                    <mat-form-field class="field-full-width" appearance="legacy">
                        <mat-label>Abdomen</mat-label>
                        <textarea matInput [(ngModel)]="contact.cardio.clinicalexam.abdomen" class="field-textarea-medium"></textarea>
                    </mat-form-field>
                </div>
                <div fxFlex="33%">
                    <mat-form-field class="field-full-width" appearance="legacy">
                        <mat-label>Pouls périphériques</mat-label>
                        <textarea matInput [(ngModel)]="contact.cardio.clinicalexam.pulseperif" class="field-textarea-medium"></textarea>
                    </mat-form-field>
                </div>
                <div fxFlex="33%">
                    <mat-form-field class="field-full-width" appearance="legacy">
                        <mat-label>Divers</mat-label>
                        <textarea matInput [(ngModel)]="contact.cardio.clinicalexam.various" class="field-textarea-medium"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Complémentaire">
            <mat-form-field class="field-full-width" appearance="legacy">
                <mat-label>Examens complémentaires</mat-label>
                <textarea matInput [(ngModel)]="contact.cardio.complementaryexam.exams" class="field-textarea"></textarea>
            </mat-form-field>
            <mat-form-field class="field-full-width" appearance="legacy">
                <mat-label>Biologie</mat-label>
                <textarea matInput [(ngModel)]="contact.cardio.complementaryexam.biology" class="field-textarea"></textarea>
            </mat-form-field>
        </mat-tab>
        <mat-tab label="Conclusion">
            <mat-form-field class="field-full-width" appearance="legacy">
                <mat-label>Conclusion</mat-label>
                <textarea matInput [(ngModel)]="contact.cardio.conclusion.conclusion" class="field-textarea"></textarea>
            </mat-form-field>
            <mat-form-field class="field-full-width" appearance="legacy">
                <mat-label>Traitement</mat-label>
                <textarea matInput [(ngModel)]="contact.cardio.conclusion.treatment" class="field-textarea"></textarea>
            </mat-form-field>
            <mat-form-field class="field-full-width" appearance="legacy">
                <mat-label>Suivi</mat-label>
                <textarea matInput [(ngModel)]="contact.cardio.conclusion.followup" class="field-textarea"></textarea>
            </mat-form-field>
        </mat-tab>
    </mat-tab-group>
</div>